import React from 'react';

import Tab from 'components/partials/tabs/tab/tab';
import classNames from 'classnames';

interface TabItem {
  value: string;
  label: string;
  icon?: React.ReactNode;
  isDisabled?: boolean;
}

interface TabsProps {
  items: TabItem[];
  activeTab: string;
  onSelect: (value: string) => void;
  customClass?: string;
  'data-testid'?: string;
}

const Tabs = ({
  items,
  activeTab,
  onSelect,
  customClass,
  'data-testid': dataTestId = 'tabs',
}: TabsProps): React.JSX.Element => (
  <div
    className={classNames(
      'text-base text-center text-navy-500 border-b w-full',
      customClass
    )}
    data-testid={dataTestId}
  >
    <ul className="flex flex-wrap -mb-px gap-5">
      {items.map((item) => (
        <Tab
          key={item.value}
          label={item.label}
          icon={item.icon}
          isActive={activeTab === item.value}
          isDisabled={item.isDisabled}
          onClick={() => onSelect(item.value)}
        />
      ))}
    </ul>
  </div>
);

export default React.memo(Tabs);
